<template>
  <div class="inventory-management">
    <b-container fluid>
      <h1>Inventory Management</h1>
      <b-row class="print-hidden">
        <b-col>
          <b-form-group label-for="filterCriteria">
            <b-input-group>
              <b-form-input type="text" id="filterCriteria" v-model="filterCriteria" class="form-control" placeholder="Type to search"></b-form-input>
              <b-input-group-append>
                <b-button @click="cleanFilterInfo()" variant="primary"></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      
      <b-button class="print-hidden" variant="primary" @click="showModal('modal-add-inventory-item')">Add an Item</b-button>

      <b-button class="print-hidden ml-2" variant="primary" @click="reminderClicked">Reminder</b-button>

      <b-button class="ml-2" v-if="user.name == 'Rick'" @click="testFunction">Test Function</b-button>

      <b-pagination
        class="my-2"
        v-model="currentPage"
        :page="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    
      <b-table
        class="pointer mt-2"
        id="my-table"
        responsive
        striped
        hover
        @row-clicked="myRowClickHandler"
        :fields="fields"
        :filter="filterCriteria"
        :items="displayed_items"
        :per-page="perPage"
        :current-page="currentPage"
        :busy="tableIsBusy"
        small
      >
      
      <!-- <template #cell(variants)="row">
        <p style="width: 440px" v-for="(item, index) in row.item.variants" :key="row.item.item_code + item.size + item.colour + index">
          <strong>{{item.size + ' ' + item.colour + ': ' + item.quantity}}</strong>
        </p>
      </template> -->
      
      </b-table>
    </b-container>

    <!-- ADD INVENTORY ITEM -->
    <b-modal size="lg" :id="'modal-add-inventory-item' + location" hide-footer :title="'Add an Item'" >
      <b-form @submit.prevent="add_inventory_item">
        <label for="warehouse_location">Warehouse Location:</label>
        <b-form-select type="text" 
          id="warehouse_location" 
          v-model="new_inventory_item.location"
          :options="warehouse_locations"
          required></b-form-select>

        <label for="item_type">Type:</label>
        <b-form-select
          id="item_type"
          v-model="new_inventory_item.item_type"
          :options="accessory_types"
          required
        ></b-form-select>
        
        <label for="item_code">Item Code:</label>
        <b-input type="text" 
          id="item_code"
          lazy
          v-model="new_inventory_item.item_code" 
          @change="newItemCodeChanged"
          required></b-input>
        <!-- <label for="item_code">Description:</label>
        <b-input type="text" 
          id="item_description" 
          v-model="new_inventory_item.item_description" 
          required></b-input>
          
        <label for="item_code">Price:</label>
        <b-input type="number" 
          id="item_price" 
          v-model="viewed_inventory_item.item_price" 
          required></b-input> -->

        <!-- <label style="display: block" for="item_variants">Variants:</label>
        <b-button size="sm" variant="primary" @click="addNewVariantToNewItem"><b-icon icon="plus-circle" variant="white"></b-icon></b-button>

        <div v-for="(variant, index) in new_inventory_item.variants" :key="item_code + variant.colour + variant.size + index" >
          <b-row>
            <b-col>
              <label for="item_size">Size:</label>
              <b-input type="text" 
                id="item_size"
                lazy
                v-model.trim="variant.size"
                @change="newItemVariantsChanged"
                required></b-input>
            </b-col>
            <b-col>
              <label for="item_colour">Colour:</label>
              <b-input type="text" 
                @change="newItemVariantsChanged"
                id="item_colour" 
                lazy
                v-model.trim="variant.colour"
                required></b-input>
            </b-col>
            <b-col>
              <label for="item_quantity">Quantity:</label>
              <b-input type="number" 
                id="item_quantity" 
                min="0"
                v-model="variant.quantity" 
                required></b-input>
            </b-col>
            <b-col>
              <label for="item_minimum">Minimum:</label>
              <b-input type="number" 
                id="item_minimum" 
                min="0"
                v-model="variant.minimum"
                required></b-input>
            </b-col>
            <b-col>
              <b-icon icon="dash-circle" variant="danger" @click="removeVariant(index)"></b-icon>
            </b-col>
          </b-row>
          
        </div> -->

        <label for="item_size">Size:</label>
        <b-input type="text" 
          id="item_size"
          lazy
          v-model.trim="new_inventory_item.size"
          @change="newItemVariantsChanged"
          required></b-input>

        <label for="item_colour">Colour:</label>
        <b-input type="text" 
          @change="newItemVariantsChanged"
          id="item_colour" 
          lazy
          v-model.trim="new_inventory_item.colour"
          required></b-input>

        <label for="item_quantity">Quantity:</label>
        <b-input type="number" 
          id="item_quantity" 
          min="0"
          v-model="new_inventory_item.quantity" 
          required></b-input>

        <label for="item_minimum">Minimum:</label>
        <b-input type="number" 
          id="item_minimum" 
          min="0"
          v-model="new_inventory_item.minimum"
          required></b-input>

        <div class="modal-footer mt-4">
          <b-button @click="hideModal('modal-add-inventory-item')"> Cancel </b-button>
          <b-button type="submit" variant="primary">
            <span v-if="!is_submitting">Add</span>
            <span v-if="is_submitting">
              <b-spinner small type="grow"></b-spinner>
              Submitting...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- VIEW INVENTORY ITEM -->
    <b-modal size="lg" :id="'modal-view-inventory-item' + location" hide-footer title="View Item">
      <b-form @submit.prevent="update_inventory_item">
        <label for="warehouse_location">Warehouse Location:</label>
        <b-form-select type="text" 
          id="warehouse_location" 
          v-model="viewed_inventory_item.location"
          :options="warehouse_locations"
          required></b-form-select>

        <label for="item_type">Type:</label>
        <b-form-select
          id="item_type"
          v-model="viewed_inventory_item.item_type"
          :options="accessory_types"
          required
        ></b-form-select>

        <label for="item_code">Item Code:</label>
        <b-input type="text" 
          id="item_code" 
          v-model="viewed_inventory_item.item_code" 
          required
          lazy
          @change="viewedItemCodeChanged"></b-input>

        <!-- <label for="item_code">Description:</label>
        <b-input type="text" 
          id="item_description" 
          v-model="viewed_inventory_item.item_description" 
          required></b-input>

        <label for="item_code">Price:</label>
        <b-input type="number" 
          id="item_price" 
          v-model="viewed_inventory_item.item_price" 
          required></b-input> -->

        <!-- <label style="display: block" for="item_variants">Variants:</label>
        <b-button size="sm" variant="primary" @click="addNewVariantToViewedItem"><b-icon icon="plus-circle" variant="white"></b-icon></b-button>

        <div v-for="(variant, index) in viewed_inventory_item.variants" :key="item_code + variant.colour + variant.size + index" >
          <b-row>
            <b-col>
              <label for="item_size">Size:</label>
              <b-input type="text" 
                id="item_size"
                lazy
                v-model.trim="variant.size"
                @change="viewedItemVariantsChanged"
                required></b-input>
            </b-col>
            <b-col>
              <label for="item_colour">Colour:</label>
              <b-input type="text" 
                @change="viewedItemVariantsChanged"
                id="item_colour" 
                lazy
                v-model.trim="variant.colour"
                required></b-input>
            </b-col>
            <b-col>
              <label for="item_quantity">Quantity:</label>
              <b-input type="number" 
                id="item_quantity" 
                min="0"
                v-model="variant.quantity" 
                required></b-input>
            </b-col>
            <b-col>
              <label for="item_minimum">Minimum:</label>
              <b-input type="number" 
                id="item_minimum" 
                min="0"
                v-model="variant.minimum"
                required></b-input>
            </b-col>
            <b-col>
              <b-icon icon="dash-circle" variant="danger" @click="removeVariantFromViewedItem(index)"></b-icon>
            </b-col>
          </b-row>
        </div> -->

        <label for="item_size">Size:</label>
        <b-input type="text" 
          id="item_size"
          lazy
          v-model.trim="viewed_inventory_item.size"
          @change="viewedItemVariantsChanged"
          required></b-input>

        <label for="item_colour">Colour:</label>
        <b-input type="text" 
          @change="viewedItemVariantsChanged"
          id="item_colour" 
          lazy
          v-model.trim="viewed_inventory_item.colour"
          required></b-input>

        <label for="item_quantity">Quantity:</label>
        <b-input type="number" 
          id="item_quantity" 
          min="0"
          v-model="viewed_inventory_item.quantity" 
          required></b-input>

        <label for="item_minimum">Minimum:</label>
        <b-input type="number" 
          id="item_minimum" 
          min="0"
          v-model="viewed_inventory_item.minimum"
          required></b-input>

        <div class="modal-footer mt-4">
          <b-button @click="showModal('modal-delete-confirmation')" variant="danger">Delete</b-button>
          <b-button @click="hideModal('modal-view-inventory-item')"> Cancel </b-button>
          <b-button type="submit" variant="warning">
            <span v-if="!is_updating">Update</span>
            <span v-if="is_updating">
              <b-spinner small type="grow"></b-spinner>
              Submitting...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- DELETE CONFIRMATION -->
    <b-modal
      :id="'modal-delete-confirmation' + location"
      title="Delete confirmation"
      hide-footer
    >
      <p>This operation will delete a record.</p>
      <div class="modal-footer mt-1">
        <b-button
          variant="secondary"
          @click="hideModal('modal-delete-confirmation')"
        >
          Cancel
        </b-button>
        <b-button
          :disabled="is_deleting"
          variant="danger"
          @click="delete_item()"
        >
          <span v-if="!is_deleting">Delete</span>
          <span v-if="is_deleting">
            <b-spinner small type="grow"></b-spinner>
            Deleting...
          </span>
        </b-button>
      </div>
    </b-modal>

    <b-modal
      :id="'modal-reminder-panel'"
      title="Reminder Panel"
      size="lg"
      hide-footer>
        <b-table
          class="pointer mt-2"
          id="my-table"
          responsive
          striped
          :fields="fields"
          :items="shortageItems"
          small
        >
        
        <template #cell(variants)="row">
          <p style="width: 440px" v-for="(item, index) in row.item.variants" :key="row.item.item_code + item.size + item.colour + index">
            <strong>{{item.size + ' ' + item.colour + ': ' + item.quantity + ' Minimum: ' + item.minimum}}</strong>
          </p>
        </template>
        
        </b-table>
    </b-modal>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import structuredClone from '@ungap/structured-clone';

export default {
  props: {
    user: Object,
  },
  computed: {
    rows: {
      get() {
        if (this.displayed_items.length == 0) {
          return 100;
        } else {
          return this.displayed_items.length;
        }
      },
      set(newRows) {
        return newRows;
      },
    },
  },
  data() {
    return {
      shortageItems: [],
      warehouse_locations: ["DAN", "TH"],
      new_inventory_item_name_ref: {},
      item_codes_dan: [],
      item_codes_th: [],
      location: "",
      item_code: "",
      variants: [],
      accessory_types: ['Cross', 'Door', 'Decoration', 'Lantern', 'Photo Frame', 'Other'],
      today: "",
      fields: [
        { key: 'item_type', label: 'Item Type'},
        { key: 'item_code', label: 'Item Code'},
        { key: 'location', label: 'Location'},
        // { key: 'item_description', label: 'Description'},
        // { key: 'item_price', label: 'Price'},
        { key: 'size', label: 'Size'},
        { key: 'colour', label: 'Colour'},
        { key: 'quantity', label: 'Qty'},
        { key: 'minimum', label: 'Minimum'},
      ],
      filterCriteria: "",
      displayed_items: [],
      items: [],
      perPage: 20,
      currentPage: 1,
      tableIsBusy: false,
      new_inventory_item: {
        id: "",
        item_type: "",
        item_code: "",
        location: "",
        variants: [],
      },
      viewed_inventory_item: {
        id: "",
        item_type: "",
        item_code: "",
        location: "",
        variants: [],
      },
      is_submitting: false,
      is_updating: false,
      is_deleting: false,
    }
  },
  created() {
    this.new_inventory_item.location = this.location;

    this.set_global_date();
    firebase.firestore().collection("inventory_test").orderBy('item_code', "asc").onSnapshot((collection) => {
      this.items = [];
      this.items = collection.docs.map(doc => doc.data());
      this.displayed_items = this.items;
    });

    this.new_inventory_item_name_ref = firebase.firestore().collection('parameters').doc("inventory_info");
    this.new_inventory_item_name_ref.get().then((doc) => {
      this.item_codes_dan = doc.data().inventory_item_code_list_dan;
      this.item_codes_th = doc.data().inventory_item_code_list_th;
    });
  },
  methods: {
    testFunction() {
      firebase.firestore().collection("inventory_test")
      .get().then((collection) => {
        var rows = collection.docs.map(doc => doc.data());
        console.log(rows.length);
        rows.forEach((e) => {
          let newAttribute = {
            size: e.variants[0].size,
            colour: e.variants[0].colour,
            quantity: e.variants[0].quantity,
            minimum: e.variants[0].minimum,
          }

          console.log(newAttribute);

          const invRef = firebase.firestore().collection("inventory_test").doc(e.id);
          invRef.set(newAttribute, {merge: true});

          // const order_simplified_ref = firebase.firestore().collection("crm_orders_simplified").doc(e.id);
          // order_simplified_ref.set(orderSimplifiedData, {merge: true});

          console.log("Uploaded");
        })
      });
    },
    reminderClicked() {
      this.shortageItems = [];
      for (const item of this.items) {
        var shortageItem = {};
        if (item.minimum && item.minimum.length > 0 && parseInt(item.quantity) < parseInt(item.minimum)) {
          shortageItem.item_type = item.item_type;
          shortageItem.item_code = item.item_code;
          shortageItem.location = item.location;
          shortageItem.size = item.size;
          shortageItem.colour = item.colour;
          shortageItem.quantity = item.quantity;
          shortageItem.minimum = item.minimum;
          this.shortageItems.push(shortageItem);
        }
      }
      console.log(this.shortageItems);
      this.showModal('modal-reminder-panel');
    },
    viewedItemCodeChanged() {
      this.viewed_inventory_item.item_code = this.viewed_inventory_item.item_code.toUpperCase();
    },
    viewedItemVariantsChanged() {
      this.viewed_inventory_item.size = this.viewed_inventory_item.size.toLowerCase();
      this.viewed_inventory_item.colour = this.viewed_inventory_item.colour.charAt(0).toUpperCase() + this.viewed_inventory_item.colour.slice(1).toLowerCase();
    },
    removeVariantFromViewedItem(index) {
      this.viewed_inventory_item.variants.splice(index, 1);
    },
    addNewVariantToViewedItem() {
      this.viewed_inventory_item.variants.push({
        size: "",
        colour: "",
        quantity: "",
        minimum: "",
      });
    },
    newItemCodeChanged() {
      this.new_inventory_item.item_code = this.new_inventory_item.item_code.toUpperCase();
    },
    newItemVariantsChanged() {
      this.new_inventory_item.size = this.new_inventory_item.size.toLowerCase();
      this.new_inventory_item.colour = this.new_inventory_item.colour.charAt(0).toUpperCase() + this.new_inventory_item.colour.slice(1).toLowerCase();
    },
    removeVariant(index) {
      this.new_inventory_item.variants.splice(index, 1);
    },
    addNewVariantToNewItem() {
      this.new_inventory_item.variants.push({
        size: "",
        colour: "",
        quantity: "",
        minimum: "",
      });
    },
    myRowClickHandler(item) {
      this.viewed_inventory_item = structuredClone(item);
      console.log(item);
      this.showModal('modal-view-inventory-item');
    },
    cleanFilterInfo() {
      this.filterCriteria = '';
    },
    hideModal(id) {
      this.$bvModal.hide(id+this.location);
    },
    showModal(id) {
      this.$bvModal.show(id+this.location);
    },
    set_global_date() {
      var date_time = new Date();
      var dd = String(date_time.getDate()).padStart(2, '0');
      var mm = String(date_time.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = date_time.getFullYear();

      this.today = yyyy + '-' + mm + '-' + dd;
      this.new_inventory_item.date = this.today;
    },
    add_inventory_item() {
      if (this.new_inventory_item.location == "DAN" && this.item_codes_dan.includes(this.new_inventory_item.item_code) 
        || (this.new_inventory_item.location == "TH" && this.item_codes_th.includes(this.new_inventory_item.item_code))) {
        alert("Cannot add existing item code");
        return;
      }

      this.is_submitting = true;

      for (var i = 0; i < this.items.length; i++) {
        console.log(this.items[i].item_code);
        if (this.items[i].location == this.new_inventory_item.location && this.items[i].item_code == this.new_inventory_item.item_code) {
          alert('There is a same item_code existing already.')
          this.is_submitting = false;
          return;
        }
      }

      const new_inventory_item_ref = firebase.firestore().collection('inventory_test').doc();

      this.new_inventory_item.id = new_inventory_item_ref.id;
      this.new_inventory_item.created_date = this.today;
      this.new_inventory_item.created_by = this.user;
      this.new_inventory_item.created_by_name = this.user.name;

      new_inventory_item_ref
        .set(this.new_inventory_item, { merge: true })
        .then(() => {
          if (this.new_inventory_item.location == "DAN" && !this.item_codes_dan.includes(this.new_inventory_item.item_code)) {
            this.item_codes_dan.push(this.new_inventory_item.item_code);
          } else if (this.new_inventory_item.location == "TH" && !this.item_codes_th.includes(this.new_inventory_item.item_code)) {
            this.item_codes_th.push(this.new_inventory_item.item_code);
          }
          this.new_inventory_item_name_ref.set(
            {inventory_item_code_list_dan: this.item_codes_dan,
            inventory_item_code_list_th: this.item_codes_th,},
            {merge: true}
          )
          
          alert('Create successfully.');
          this.hideModal('modal-add-inventory-item');

          this.is_submitting = false;
          this.new_inventory_item = {
            id: "",
            item_type: "",
            item_code: "",
            location: this.location,
            variants: [],
          };
        });
    },
    update_inventory_item() {
      this.is_updating = true;

      firebase
        .firestore()
        .collection("inventory_test")
        .doc(this.viewed_inventory_item.id)
        .set(this.viewed_inventory_item, { merge: true })
        .then(() => {
          alert("Modify successfully");
          this.is_updating = false;
        });
    },
    delete_item() {
      this.is_deleting = true;
      firebase
        .firestore()
        .collection("inventory_test")
        .doc(this.viewed_inventory_item.id)
        .delete().then(() => {

          if (this.viewed_inventory_item.location == "DAN") {
            this.item_codes_dan.splice(this.item_codes_dan.indexOf(this.viewed_inventory_item.item_code), 1);
          } else if (this.viewed_inventory_item.location == "TH") {
            this.item_codes_th.splice(this.item_codes_th.indexOf(this.viewed_inventory_item.item_code), 1);
          }

          this.new_inventory_item_name_ref.set(
            {inventory_item_code_list_dan: this.item_codes_dan,
            inventory_item_code_list_th: this.item_codes_th,},
            {merge: true}
          )

          alert('Delete successfully.');
          this.is_deleting = false;
          this.hideModal('modal-view-inventory-item');
          this.hideModal('modal-delete-confirmation');
        });
    },
  },
}
</script>

<style>

</style>